// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ccc58edf","455":"68c33e2e","977":"e3ac5982"}[chunkId] + ".chunk.js";
};